import { Component } from "react";
import AsyncSelect from "react-select/async";
import debounce from "debounce-promise";

class DebounceAsync extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: null,
    };

    const wait = this.props.waitTime || 1000; // milliseconds
    const loadOptions = inputValue => this._handleChange(inputValue);
    this.debouncedLoadOptions = debounce(loadOptions, wait);
  }

  _handleChange = inputValue => {
    const { loadOptions } = this.props;

    return new Promise((resolve, reject) => {
      loadOptions(inputValue, resolve, reject);
    });
  };

  handleSelectChange = selectedOption => {
    this.setState({ selectedOption: null });

    // Call the passed onChange handler
    if (this.props.onChange) {
      this.props.onChange(selectedOption);
    }
  };

  render() {
    const { results, loadOptions, onChange, ...rest } = this.props;

    return (
      <AsyncSelect
        loadOptions={this.debouncedLoadOptions}
        placeholder="Search..."
        openMenuOnFocus={false}
        openMenuOnClick={false}
        isSearchable={true}
        isClearable={true}
        escapeClearsValue={true}
        closeMenuOnSelect={true}
        blurInputOnSelect={true}
        components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
        loadingMessage={inputObject => `Searching for ${inputObject.inputValue}`}
        noOptionsMessage={() => (results.length === 0 ? null : "No result")}
        classNamePrefix="react-select"
        value={this.state.selectedOption}
        onChange={this.handleSelectChange}
        {...rest}
      />
    );
  }
}

export default DebounceAsync;